import React, { useEffect, useState, useContext, useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import { notificationActions } from '../../../actions/notification.actions.js';
import { content_groupActions, work_spaceActions, user_profileActions } from '../../../actions';
import { Table, Button, Spinner } from 'react-bootstrap';
import ContentList from "../ContentPage/list";
import InfiniteScroll from 'react-infinite-scroll-component';
import NotificationRow from './notificationRow';
import { TopbarContext } from '../../../contexts/TopbarContext.js';
import { buildFormDataFromObject } from '../../../utils/commonUtils.js';
import { NotificationAllReadChecker } from '../../../components/notifications/NotificationAllReadChecker.js';
import NotificationFilterButtonGroup from '../../../components/notifications/NotificationFilterButtonGroup.js';
import { notificationConstants, notificationFilterConstants } from '../../../constants/notification.constants.js';
import useNotificationListPageHook from '../../../hooks/useNotificationListPageHook.js';
import useNotificationActionCable from '../../../hooks/useNotificationActionCable.js';
import { RefreshIcon } from '../../../components/icons/RefreshIcon.js';
import { groupByDay } from '../../../helpers/groupByDay.js';
import { dayFormatter } from '../../../helpers/dayFormatter.js';

function NotificationsPage({
  notifications, 
  can_access_content, 
  can_access_edit_title, 
  deleted_notification, 
  updated_notification,
  notification_load,
}) {
  // Variables
  const dispatch = useDispatch();

  // State
  const [ contentGroupPopUp, setContentGroupPopUp] = useState({id: null, show: false });
  const [ highlighted_comment, setHighlightedComment] = useState({id: null, internal: false, cg_id: null});
  const [ workspaceId, setWorkspaceId] = useState();

  // Context
  const { 
    enable_notification_ring, 
    setEnableNotificationRing 
  } = useContext(TopbarContext);  

  // Redux 
  const { 
    selected_filter, 
    unselected_workspace_ids, 
    unselected_organization_ids,
    id: filter_id, 
  } = useSelector(state => state.notification_filter);
  const { work_space } = useSelector(state => state.work_space);
  const {
    new_notification
  } = useSelector(state => state.notification);

  const {
    notification_list,
    notification_list_has_more
  } = useSelector(state => state.notification);

  const grouped_notifications = useMemo(() => groupByDay(notification_list), [notification_list]);

  // Hooks
  const { 
    filter_activites, 
    set_filter_activites 
  } = useNotificationListPageHook();

  useEffect(() => {
    loadNotifications(null)
  }, [
    filter_activites, 
    selected_filter
  ]);

  // Functions
  const handleToggleNotificationRing = () => {
    let formData = new FormData();

    buildFormDataFromObject(formData, {enable_notification_ring: !enable_notification_ring}, "user");

    const success_callback = (res) => {
      setEnableNotificationRing(prevState => res.enable_notification_ring)
    }
    
    dispatch(user_profileActions.updateNotificationRingSetting(formData, success_callback));
  }

  const loadNextPage = () => {
    let lastNotificationId = notifications[notifications.length - 1].id
    loadNotifications(lastNotificationId)
  }

  const loadNotifications = (lastNotificationId, ) => {
    const filter_type = null;
    const filter = selected_filter === null ? null : selected_filter;
    const filterWorkspaceOnInitialize = true;

    let onSuccess = (data) => {
      if (lastNotificationId) {
        dispatch({ type: notificationConstants.APPEND_NOTIFICATION_LIST, payload: data.data })
        dispatch({ type: notificationConstants.SET_NOTIFICATION_LIST_HAS_MORE, payload: data.data.length > 0 })
      } else {
        dispatch({ type: notificationConstants.SET_NOTIFICATION_LIST, payload: data.data })
        dispatch({ type: notificationConstants.SET_NOTIFICATION_LIST_HAS_MORE, payload: data.has_next_page })
      }
    }

    dispatch(notificationActions.getPage({
                                          only_unread: filter_activites, 
                                          lastNotificationId, 
                                          onSuccess, 
                                          filter_type, 
                                          filter,
                                          filterWorkspaceOnInitialize,
                                          unselected_organization_ids,
                                          unselected_workspace_ids
                                        }))
  }

  const handleReadAll = () => {
    dispatch(notificationActions.readAll(() => loadNotifications(null)));
  }

  const onSwitchNotificaton = () => {
    set_filter_activites(!filter_activites)
  }

  const handleCloseContentGroupPopUp = () => {
    setContentGroupPopUp({id: null, show: false})
    setHighlightedComment({id: null, internal: false, cg_id: null});
  }

  const handleInlineEdit = (handleOnBlur, values, content_group_id) => {
    dispatch(content_groupActions.inlineEditContentGroup(handleOnBlur, values, content_group_id, workspaceId));
  }

  const refreshNotifications = () => {
    const filter_type = null;
    const filter = null;
    const filterWorkspaceOnInitialize = false;

    let onSuccess = (data) => {
      dispatch({type: notificationFilterConstants.SELECT_NOTIFICATION_FILTER, payload: null});
      dispatch({ type: notificationFilterConstants.RESET_ORGANIZATION_AND_WORKSPACE_FILTERS, payload: null });

      dispatch({ type: notificationConstants.SET_NEW_NOTIFICATION, payload: null })
      dispatch({ type: notificationConstants.SET_NOTIFICATION_LIST, payload: data.data })
      dispatch({ type: notificationConstants.SET_NOTIFICATION_LIST_HAS_MORE, payload: data.has_next_page })
    }

    dispatch(notificationActions.getPage({
                                          only_unread: filter_activites, 
                                          lastNotificationId: null,
                                          onSuccess, 
                                          filter_type, 
                                          filter,
                                          filterWorkspaceOnInitialize,
                                          unselected_organization_ids: [],
                                          unselected_workspace_ids: []
                                        }))
  }

  // Show Button if there is a new notification received via Action Cable that is not loaded yet
  const isNewNotificationRetrieved = useCallback(() => {
    if(new_notification === null) return false;

    const isExist = notification_list.find((notification) => notification.id === new_notification.id);

    return !isExist;
  }, [new_notification, notification_list]);


  return (
    <>
      <div className="layout__container-wrapper--notifications">
        <div className='mb-3 d-lg-flex align-items-center justify-content-between notifications--header'>
          <div className='d-flex align-items-center'>
            <h2 
              className="organization_title font-weight-bold text-truncate ">
                Notifications
              </h2>
            { isNewNotificationRetrieved() &&
              <Button 
                variant={'cyan'} 
                className='rounded-pill d-flex refresh-notification-button box-shadow-sm'  
                size='sm'
                onClick={refreshNotifications}
              >
                <div 
                  className='d-flex align-items-center justify-content-center refresh-icon-container'
                >
                  <RefreshIcon />
                </div>
                
                <span className='d-flex align-items-center'>New Update</span>
              </Button>
            }
          </div>

          <div className="d-flex align-items-center justify-content-between mb-1">
            <div className="d-flex notifications--button-group align-items-center">
              <Button
                className=''
                onClick={handleToggleNotificationRing}
                variant={enable_notification_ring ? 'orange' : 'outline-fill-gray'}
              >
                <span>
                  Sound { enable_notification_ring ? 'On' : 'Off'}
                </span>
              </Button>
              <Button 
                variant={'outline-fill-gray'}
                onClick={onSwitchNotificaton} 
              >
                {
                  filter_activites ? 
                    'Show Unread' :
                    'Hide Unread'
                }
              </Button>
              <Button variant={'outline-fill-gray'} onClick={handleReadAll}>Mark All Read</Button>

            </div>
          </div>
        </div>
        <div className='notifications--notification-list-container'>
          <div className='d-lg-flex justify-content-between align-items-center'>
            <NotificationFilterButtonGroup />
          </div>
          <InfiniteScroll
            dataLength={notification_list?.length}
            hasMore={notification_list_has_more}
            loader={
              <div className="clearfix">
                <div className="spinner-container">
                  <Spinner animation="border" />
                </div>
              </div>
            }
            next={loadNextPage}
            scrollableTarget="mainContainer"
          >
            <div>
            { grouped_notifications ?
                Object.entries(grouped_notifications).map(([day, notifications], index) => (
                  <div key={day}>
                    <div className="notification__day-label" data-label={dayFormatter(day)}>
                      {dayFormatter(day)}
                    </div>
                    {
                      notifications.map((data, idx) => (
                        <NotificationRow
                          mode="notification"
                          data={ data }
                          key={ "notification_list_"+data.id }
                          setWorkspaceId={ setWorkspaceId }
                          setContentGroupPopUp={ setContentGroupPopUp }
                          setHighlightedComment={setHighlightedComment}
                          readable={true}
                        />
                      ))
                    }
                  </div>
            ))
              :
                null
            }
            </div>
          </InfiniteScroll>
        </div>


        {
          notification_list_has_more  === false && filter_activites && 
          <div className="d-flex justify-content-center py-4">
            <NotificationAllReadChecker notifications={notification_list}/>
          </div>
        }

      </div>
      { contentGroupPopUp.show &&
          <ContentList
            content_group_id={contentGroupPopUp.id}
            workspace_id={workspaceId}
            updated_at={work_space && work_space.updated_at}
            handleCloseContentGroupPopUp={handleCloseContentGroupPopUp}
            handleInlineEdit={handleInlineEdit}
            setContentGroupPopUp={setContentGroupPopUp}
            can_access_content={can_access_content}
            highlighted_comment={highlighted_comment}
            can_access_edit_title={can_access_edit_title}
            content_popup_notification="show_content_notification"
          />
      }
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    loading: state.workspaceUser.loading,
    notifications: state.notification.notifications,
    notification_load: state.notification.notification_load,
    deleted_notification: state.notification.deleted_notification,
    updated_notification: state.notification.updated_notification,
    can_access_content: state.notification.can_access_content,
    can_access_edit_title: state.notification.can_access_edit_title
  };
};

export default connect(mapStateToProps, { notificationActions })(NotificationsPage);
